import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    meta: {
      icon: 'mdi:person-multiple',
      order: 60,
      title: 'GG业务管理',
    },
    name: 'AdGGBusiness',
    path: '/GG-business',
    children: [
      {
        name: 'AdGGAccount',
        path: '/gg-account',
        component: () => import('#/views/GG-business/account-list/index.vue'),
        meta: {
          icon: 'mdi:account-outline',
          title: '账户管理',
          keepAlive: true,
        },
      },
      {
        name: 'AdGGApplyAccount',
        path: '/gg-apply-account',
        component: () =>
          import('#/views/GG-business/apply-account-list/index.vue'),
        meta: {
          icon: 'mdi:account-add-outline',
          title: '开户管理',
          keepAlive: true,
        },
      },
      {
        name: 'AdGGAccountAssign',
        path: '/gg-account-assign',
        component: () =>
          import('#/views/GG-business/account-assign-list/index.vue'),
        meta: {
          icon: 'mdi:share-variant-outline',
          title: '账户分配',
          keepAlive: true,
        },
      },
      {
        name: 'AdGGAccountRecharge',
        path: '/gg-account-recharge',
        component: () =>
          import('#/views/GG-business/account-recharge/index.vue'),
        meta: {
          icon: 'mdi:account-multiple-plus-outline',
          title: '账户充值',
          keepAlive: true,
        },
      },
      {
        name: 'AdGGAccountSubtraction',
        path: '/gg-account-subtraction',
        component: () =>
          import('#/views/GG-business/account-subtraction/index.vue'),
        meta: {
          icon: 'mdi:account-minus-outline',
          title: '账户减款',
          keepAlive: true,
        },
      },
      {
        name: 'AdGGAccountClear',
        path: '/gg-account-clear',
        component: () => import('#/views/GG-business/account-clear/index.vue'),
        meta: {
          icon: 'mdi:clear-circle-multiple',
          title: '账户清零',
          keepAlive: true,
        },
      },
      {
        name: 'AdGGServiceFeeConfig',
        path: '/gg-service-fee-config',
        component: () =>
          import('#/views/GG-business/service-fee-config/index.vue'),
        meta: {
          icon: 'mdi:settings-outline',
          title: '账户服务费',
          keepAlive: true,
        },
      },
    ],
  },
]

export default routes
